module.exports = __webpack_public_path__ + "static/media/amz_FRONT_RIGHT.2c1675a0.svg";